import { AssetRef } from '../../../types/typing';

const updateAssetPosition = (assetRef: AssetRef) => {
  if (!assetRef.container) return;
  assetRef.container.style.transform = `translate(${assetRef.position.x - 100}px, ${assetRef.position.y - 100}px) scale(${assetRef.scale})`;
};

export const renderAsset = (
  assetData: any,
  index: number,
  width: number,
  height: number,
  onUpdateAsset: any,
  pixiContainer: any,
  assetsRef: any,
  activeAssetRef: any,
  dragStateRef: any
): (() => void) => {
  if (!pixiContainer.current || assetsRef.current.has(index)) {
    return () => {};
  }

  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.width = '200px';
  container.style.height = '200px';
  container.style.transformOrigin = 'center center';
  container.style.cursor = 'pointer';
  container.style.zIndex = '1';
  container.setAttribute('data-asset-index', index.toString());
  pixiContainer.current.appendChild(container);

  const img = document.createElement('img');
  img.src = assetData.url;
  img.style.width = '100%';
  img.style.height = '100%';
  container.appendChild(img);

  const initialX = assetData.position?.x || width / 2;
  const initialY = assetData.position?.y || height / 2;
  const initialScale = assetData.scale || 1;

  const assetRef: AssetRef = {
    container,
    url: assetData.url,
    isDragging: false,
    position: { x: initialX, y: initialY },
    scale: initialScale,
  };

  assetsRef.current.set(index, assetRef);

  updateAssetPosition(assetRef);

  const handleMouseDown = (e: MouseEvent) => {
    e.preventDefault();
    dragStateRef.current.isDragging = true;
    activeAssetRef.current = { index, ref: assetRef };
    dragStateRef.current.startPos = {
      x: e.clientX - assetRef.position.x,
      y: e.clientY - assetRef.position.y,
    };
    container.style.opacity = '0.8';

    const handleMouseMove = (moveEvent: MouseEvent) => {
      if (dragStateRef.current.isDragging && activeAssetRef.current?.ref) {
        const asset = activeAssetRef.current.ref;
        const newX = moveEvent.clientX - dragStateRef.current.startPos.x;
        const newY = moveEvent.clientY - dragStateRef.current.startPos.y;

        asset.position = { x: newX, y: newY };
        updateAssetPosition(asset);
        onUpdateAsset(index, { position: asset.position });
      }
    };

    const handleMouseUp = () => {
      dragStateRef.current.isDragging = false;
      container.style.opacity = '1';
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleWheel = (e: WheelEvent) => {
    e.preventDefault();
    const scaleDelta = e.deltaY > 0 ? 0.9 : 1.1;
    const newScale = assetRef.scale * scaleDelta;

    if (newScale >= 0.1 && newScale <= 5) {
      assetRef.scale = newScale;
      updateAssetPosition(assetRef);
      onUpdateAsset(index, { scale: newScale });
    }
  };

  container.addEventListener('mousedown', handleMouseDown);
  container.addEventListener('wheel', handleWheel);

  return () => {
    container.removeEventListener('mousedown', handleMouseDown);
    container.removeEventListener('wheel', handleWheel);
    container.remove();
    assetsRef.current.delete(index);
  };
};
